import { Component, OnInit } from '@angular/core';
import { UiStateService } from './core/services/ui-state-service';
import { DEALER_RESOURCES_STORAGE_KEY } from './dealers/custom-dealer-resource-map';
import { DataStateService } from './core/services/data-state.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'proef';

  public constructor(private uiState: UiStateService, private dataStateService: DataStateService,) {

  }

  public ngOnInit() {
    const cachedDealerResources = sessionStorage.getItem(DEALER_RESOURCES_STORAGE_KEY);
    if (cachedDealerResources) {
      const dealerResources = JSON.parse(cachedDealerResources);
      this.uiState.setCustomDealerResources({
        primary: dealerResources.primaryColor,
        secondary: dealerResources.secondaryColor,
        text: dealerResources.textColor,
        image: dealerResources.logoLink,
        sleutel: dealerResources.dealerGUID
      });
      this.dataStateService.setLandingPagePath(`/${dealerResources.dealerGUID}`);
    }
  }
}
